import { trackEvent } from '../../utils/analytics';

export default () => next => action => {
  trackEvent({
    category: 'Event',
    action: action.type
  });

  next(action);
};
